import { callExternalApi, CallResult } from '../callExternalApi';
import { PaginatedResponse } from '../../store/GeneralStore';

export type McpAccessScope = 'read_only' | 'read_write';

export interface McpAccessProfile {
  access_id: string;
  title: string;
  scope: McpAccessScope;
  last_used_at: string | null;
  last_used_tool_name: string | null;
  last_used_client_name: string | null;
  created_at: string;
  updated_at: string;
}

export interface McpAccessProfileWithToken extends McpAccessProfile {
  token: string;
}

export interface CreateMcpAccessProfileRequest {
  access_profile: {
    title: string;
    scope: McpAccessScope;
  };
}

export interface McpToolInvocation {
  id: number;
  tool_name: string;
  client_name: string | null;
  created_at: string;
}

const JSON_HEADERS = { 'content-type': 'application/json' };

export const getMcpAccessProfilesApi = async (): Promise<CallResult<McpAccessProfile[]>> => {
  return await callExternalApi<McpAccessProfile[]>({
    url: 'api/mcp-access',
    method: 'GET',
    headers: JSON_HEADERS
  });
};

export const createMcpAccessProfileApi = async (
  requestBody: CreateMcpAccessProfileRequest
): Promise<CallResult<McpAccessProfileWithToken>> => {
  return await callExternalApi<McpAccessProfileWithToken>({
    url: 'api/mcp-access',
    method: 'POST',
    headers: JSON_HEADERS,
    data: requestBody
  });
};

export const rotateMcpAccessProfileApi = async (accessId: string): Promise<CallResult<McpAccessProfileWithToken>> => {
  return await callExternalApi<McpAccessProfileWithToken>({
    url: `api/mcp-access/${accessId}/rotate`,
    method: 'POST',
    headers: JSON_HEADERS
  });
};

export const getMcpAccessAuditApi = async (
  accessId: string,
  page = 1,
  perPage = 25
): Promise<CallResult<PaginatedResponse<McpToolInvocation>>> => {
  return await callExternalApi<PaginatedResponse<McpToolInvocation>>({
    url: `api/mcp-access/${accessId}/audit`,
    method: 'GET',
    params: { page, per_page: perPage },
    headers: JSON_HEADERS
  });
};

export const deleteMcpAccessProfileApi = async (accessId: string): Promise<CallResult<void>> => {
  return await callExternalApi<void>({
    url: `api/mcp-access/${accessId}`,
    method: 'DELETE',
    headers: JSON_HEADERS
  });
};
